import { isNil, omitBy } from 'lodash';
import { joinUrl } from '@/constants/urls';
import { UserDefinedRestrictionTypes } from '../constants';
import { restrictionsAttachmentsMap } from '../helper';

const buildLinkRestrictionContext = (datasetCondition) => omitBy(
  {
    type: UserDefinedRestrictionTypes.LINK,
    link: joinUrl(datasetCondition.context),
    link_display_name: datasetCondition.context?.link_display_name,
    text: datasetCondition.context?.text,
  },
  isNil,
);

const buildAttachmentRestrictionContext = (datasetCondition) => ({
  type: UserDefinedRestrictionTypes.ATTACHMENT,
  text: datasetCondition.context.text,
  attachment: restrictionsAttachmentsMap.get(datasetCondition.context.attachmentMapId),
});

const buildTextRestrictionContext = (datasetCondition) => ({
  type: UserDefinedRestrictionTypes.TEXT,
  text: datasetCondition.context.text,
});

const restrictionContextBuilders = {
  [UserDefinedRestrictionTypes.LINK]: buildLinkRestrictionContext,
  [UserDefinedRestrictionTypes.ATTACHMENT]: buildAttachmentRestrictionContext,
  [UserDefinedRestrictionTypes.TEXT]: buildTextRestrictionContext,
};

const buildContext = (datasetCondition) => {
  const restrictionContextBuilder = restrictionContextBuilders[datasetCondition?.context?.type];

  return restrictionContextBuilder ? restrictionContextBuilder(datasetCondition) : datasetCondition.context;
};

export default buildContext;
